/**
 * Created by mqamhieh on 10/17/17.
 */
window.UploadApplicantForm = function (scope, hUser, Upload, userServices, userPermissions) {
    var self = this;
    var formName = "upload-applicant-form";
    var _protected = BaseForm.call(self, formName, scope);

    self.parseAllowed = true;
    self.data.application_documents_code = [];
    var BRAND_LIST_LIMIT = 200;

    self.onJobChanged = function () {
        userServices.isServiceEnabled(userServices.SERVICES.GDPR, self.data.job.Brand.id)
            .then(function (isGDPREnabled) {
                self.isGDPREnabled = isGDPREnabled;
            });

        userServices.isServiceEnabled(userServices.SERVICES.ON_BOARDING, self.data.job.Brand.id)
            .then(function (isOnBoardingEnabled) {
                self.isOnBoardingEnabled = isOnBoardingEnabled;
            });

        self.loadJobAppOptions();
    };

    self.loadJobAppOptions = function () {
        var defer = $q.defer();

        self.loadingDocs = true;

        JobApplicationAPI.getJobAppOptions(self.data.job.Brand.id, self.data.job.id)
            .then(function (response) {
                if (response) {
                    if (response.application_options) {
                        self.data.application_documents_code = response.application_options.filter(function (option) {
                            return (option.code === 'APPLICATION_DOCUMENT');
                        });
                    }
                }
            }).finally(function () {
            self.loadingDocs = false;
            defer.resolve();
            scope.$digest();
        });

        return defer.promise;
    };

    self.getReferrerList = function (brandId, categoryId) {
        var defer = $q.defer();
        self.sourceLoading = true;
        JobApplicationAPI.getReferrerList(brandId, categoryId)
            .then(function (list) {
                self.sources = list;
                self.sourceLoading = false;
                defer.resolve();
                scope.$digest();
            }, function () {
                defer.reject();
            });
    };

    self.getInternalEmployeeReferrer = function ($event) {
        let searchedReferrer = $event.value;
        var defer = $q.defer();
        $event.on('start');
        let parmas = {
            offset: 0,
            limit: 15,
        };
        if (searchedReferrer) {
            parmas['search_fields'] = [{
                "value": searchedReferrer,
                "field": 'full_name'
            }]
        }

        let userData = hUser.data && hUser.data.user;
        let brandsList = userData && userData.brands_list || [];
        let brandId = (userData && userData.entry_mode && userData.entry_mode.brand_id) || (brandsList[0] && brandsList[0].id);

        TeamAPI.getBrandUsers(brandId, parmas)
            .then(function (data) {
                let items = data.users
                self.setFullNames(items);
                defer.resolve(items);
            }).catch(function () {
            defer.resolve([]);
        }).finally(function () {
            $event.on('end');
        });

        return defer.promise;
    };

    self.getExternalEmployeeReferrer = function ($event) {
        let searchedReferrer = $event.value;
        $event.on('start');
        var defer = $q.defer();

        let parmas = {
            offset: 0,
            limit: 15,
            search_term: searchedReferrer,
            sort_by: 'name'
        };
        SocialReferralAPI.getExternalReferrals(parmas)
            .then(function (data) {
                let items = data.external_referrals;
                self.setFullNames(items);
                defer.resolve(items);
            }).catch(function () {
            defer.resolve([]);
        }).finally(function () {
            $event.on('end');
        });

        return defer.promise;
    };

    self.setFullNames = function (userList) {
        userList.forEach(function (user) {
            user.full_name = user.first_name + ' ' + user.last_name;
        });
    };
    self.onSelectedCategoryChanged = function () {
        if (self.data.category && self.data.category.code !== 'UPLOADED' && self.data.category.code != 'EMPLOYEE_REFERRAL') {
            self.getReferrerList(self.data.job.Brand.id, self.data.category.id);
        }
        delete self.data.employee_referrer_type;
        delete self.data.referrar;
    };

    self.load = function (job, isGDPREnabled, fromApplicant) {
        var defer = $q.defer();

        self.isGDPREnabled = isGDPREnabled;
        self.fromApplicant = fromApplicant;

        if (job) {
            job.name = job.alias_position || job.Position.name;
            self.activeJobs = [job];
            self.data.job = self.activeJobs[0];
            self.onJobChanged();
            self.jobDisabled = true;
            defer.resolve();
        } else {
            BrandAPI.getGroupJobs(hUser.getUserContext().brand_id)
                .then(function (brandsJobs) {
                    self.activeJobs = [];
                    for (var i in brandsJobs) {
                        for (var j in brandsJobs[i].Jobs) {
                            var job = brandsJobs[i].Jobs[j];
                            job.Brand = brandsJobs[i].Brand;
                            self.activeJobs.push(job);
                        }
                    }
                    self.data.job = self.activeJobs[0];
                    defer.resolve();
                    scope.$digest();
                }, function () {
                    defer.reject();
                });
        }
        self.categoryLoading = true;
        JobApplicationAPI.getSourcesCategories(hUser.getUserContext().brand_id)
            .then(function (categories) {
                self.categories = categories;
                let selectedCategory = self.categories.filter(function (category) {
                    return category.code === 'UPLOADED';
                });
                self.data.category = selectedCategory[0];
                self.categoryLoading = false;
                defer.resolve();
                scope.$digest();
            }, function () {
                defer.reject();
            });

        return defer.promise;
    };

    self.getBrandsBySearchQuery = function ($event) {
        var defer = $q.defer();

        $event.on('start');
        var searchedBrand = $event.value;

        BrandAPI.getUserBrandsList(BRAND_LIST_LIMIT, 0, searchedBrand, false, false).then(function (data) {
            const allBrands = data.brands.flatMap(item => item.brands);
            defer.resolve(allBrands);
            $event.on('end');
        }, function (error) {
            defer.reject(error);
            $event.on('end');
        });

        return defer.promise;
    };

    self.onFileSelect = function (files) {
        delete self.selectedFile;
        delete self.fileTypeErrorMsg;

        if (files && files[0]) {
            var fileType = files[0].name.split('.');
            fileType = fileType[fileType.length - 1];
            if (['pdf', 'doc', 'docx', 'txt', 'rtf'].indexOf(fileType) == -1) {
                self.fileTypeErrorMsg = "Unsupported file type: " + files[0].name + ". Allowed formats: pdf, doc, docx, txt, rtf";
            }
            else {
                self.selectedFile = files[0];
            }
        }
    };

    self.onDeleteResumeSelectedFile = function () {
        delete self.selectedFile;
        delete self.fileTypeErrorMsg;
    };

    self.onAppDocFileSelect = function (files,index) {
        delete self.data.application_documents_code[index].selectedFile;
        delete self.data.application_documents_code[index].fileTypeErrorMsg;

        if (files && files[0]) {
            var fileType = files[0].name.split('.');
            fileType = fileType[fileType.length - 1];
            if (['pdf', 'doc', 'docx', 'txt', 'rtf'].indexOf(fileType) == -1) {
                self.data.application_documents_code[index].fileTypeErrorMsg = "Unsupported file type: " + files[0].name + ". Allowed formats: pdf, doc, docx, txt, rtf";
            }
            else {
                self.data.application_documents_code[index].selectedFile = files[0];
            }
        }
    };

    self.onDeleteAppDocSelectedFile = function (index) {
        delete self.data.application_documents_code[index].selectedFile;
        delete self.data.application_documents_code[index].fileTypeErrorMsg;
    };

    self.onRequestError = function (description) {
        HNotifications.show({
            title: 'Error',
            desc: description,
            icon: "fa-times",
            type: "danger"
        });
    };

    self.loadAppDocs = function (defer, applicant_data) {
        self.data.application_documents_code.forEach(function (appDoc,index) {
            if (appDoc.selectedFile){
                self.uploadProgress =0;
                JobApplicationAPI.getAppMediaPresignedUrl(applicant_data.application_id, appDoc.application_document.id, appDoc.selectedFile.name).then(function (response) {
                    Upload.http({
                        url: response.href,
                        method: 'PUT',
                        headers: {
                            'Content-Type': ''
                        },
                        data: appDoc.selectedFile,
                    }).success(function () {
                        var payload = {
                            'path': response.href,
                            'type': "application_document",
                            'application_document_id': appDoc.application_document.id,
                            'display_name':appDoc.selectedFile.name
                        };
                        JobApplicationAPI.uploadAppMedia(applicant_data.application_id, payload).then(function () {
                            if (index === self.data.application_documents_code.length -1) {
                                delete self.saving;
                                defer.resolve({jobData: self.data.job, applicant: applicant_data});
                            }
                        }).catch(function (reason) {
                            delete self.saving;
                            console.error("Error while uploading:", reason);
                            self.saveError = true;
                            defer.reject(reason);
                            self.onRequestError($filter("translate")("Your applicant was added but some documents were not uploaded."));
                        });
                    }).progress(function (evt) {
                        self.uploadProgress = parseInt(100.0 * evt.loaded / evt.total);
                    }).error(function (reason) {
                        delete self.saving;
                        console.error("Error while uploading:", reason);
                        self.saveError = true;
                        defer.reject(reason);
                        self.onRequestError($filter("translate")("Your applicant was added but some documents were not uploaded."));
                    });
                }).catch(function (reason) {
                    delete self.saving;
                    console.error("Error while uploading:", reason);
                    self.saveError = true;
                    defer.reject(reason);
                    self.onRequestError($filter("translate")("Your applicant was added but some documents were not uploaded."));
                });
            } else if (index === self.data.application_documents_code.length -1) {
                delete self.saving;
                defer.resolve({jobData: self.data.job, applicant: applicant_data});
            }
        });
    };

    var checkIfBlockedUser = function () {
        var defer = $q.defer();
        if (self.data.user_id) {
            var promises = {};
            if (self.isOnBoardingEnabled) {
                promises['users'] = OnBoardingAPI.getProspectsByUserIds(self.data.job.Brand.id, [self.data.user_id], ['SERVICE_ENDED', 'HIRED']);
            }
            promises['policyParser'] = userPermissions.getBrandPolicy(self.data.job.Brand.id);
            $q.all(promises).then(function (res) {
                var user = res['users'] && res['users'][0] || {};
                var policyParser = res['policyParser'];
                var canRehireBlockedEmployees = policyParser.has(userPermissions.PERMISSIONS.MANAGE_BLOCKED_PAST_EMPLOYEES);
                if (user.is_blocked) {
                    if (canRehireBlockedEmployees) {
                        hConfirm({
                            title: $filter("translate")("Blocked for rehire"),
                            text: $filter("translate")("This employee has been blocked for rehire. Are you sure you want to rehire this employee?"),
                            confirmButton: $filter("translate")("Yes"),
                            cancelButton: $filter("translate")("Cancel"),
                            callback: function (confirmed) {
                                if (confirmed) {
                                    defer.resolve();
                                } else {
                                    defer.reject();
                                }
                            }
                        });
                    } else {
                        hAlert({
                            title: $filter("translate")("Failed to rehire"),
                            text: $filter("translate")("This employee has been blocked for rehire. For more info, please contact the HR manager."),
                            custom_class: 'rejection-templates-error-alert',
                            button: {
                                text: $filter("translate")("Okay")
                            }
                        });
                        defer.reject();
                    }
                } else {
                    defer.resolve();
                }
            }).catch(function (err) {
                console.error(err);
                defer.reject(err);
            });
        } else {
            defer.resolve();
        }
        return defer.promise;
    };
    self.onEmployeeReferralChanged = function (selected) {
        self.data.employeeReferrer = angular.copy(selected);
    };

    self.onBrandChanged = function (selected) {
        var defer = $q.defer();
        self.data.brandSelected = angular.copy(selected[0]);
        self.activeJobs = [];
        self.loadingJobs = true;

        BrandAPI.getBrandJobs(self.data.brandSelected.id, true, false)
            .then(function (data) {
                for (var i in data.brands) {
                    for (var j in data.brands[i].jobs) {
                        var job = data.brands[i].jobs[j];
                        job.Brand = data.brands[i];
                        self.activeJobs.push(job);
                    }
                }

                self.loadingJobs = false;
                defer.resolve();
                scope.$digest();
            }, function () {
                self.loadingJobs = false;
                defer.reject();
            });
    };


    self.save = function () {
        var defer = $q.defer();

        delete self.saveError;
        delete self.employerConnotApply;
        delete self.userAlreadyApplied;
        self.saving = true;
        checkIfBlockedUser().then(function () {
            self.uploadProgress = 0;

            var dataToSend = {
                file: self.selectedFile,
                user_id: self.data.user_id,
                email: self.data.email,
                first_name: self.data.first_name,
                last_name: self.data.last_name,
                received_applicant_consent: !!self.data.received_applicant_consent
            };
            if (self.data.category) {
                if (self.data.category.code === 'EMPLOYEE_REFERRAL') {
                    dataToSend['referrer'] = 'SOCIAL_REFERRAL';
                    self.data.employee_referrer_type === 'EXTERNAL' ? dataToSend['job_referrer_external_id'] = self.data.employeeReferrer[0].id : dataToSend['job_referrer_internal_id'] = self.data.employeeReferrer[0].user_id;
                } else {
                    if (self.data.category.code !== 'UPLOADED') {
                        dataToSend['referrer'] = self.data.referrar.utm_source;
                    }
                }
            }

            if (!self.existingEmail) {
                dataToSend['phone'] = window.intlTelInputUtils.formatNumber(self.data.phone, undefined, window.intlTelInputUtils.numberFormat.E164);
            }

            Upload.upload({
                'url': publicConfiguration.APIServerBaseURL + 'brands/' + self.data.job.Brand.id + '/jobs/' + self.data.job.id + '/users/applications',
                'withCredentials': true,
                'headers': {},
                'method': 'POST',
                'Content-Type': 'multipart/form-data',
                'data': dataToSend
            }).progress(function (evt) {
                self.uploadProgress = parseInt(100.0 * evt.loaded / evt.total);
            }).success(function (data, status, headers, config) {
                // file is uploaded successfully
                if (data && data.data && data.status_code == 200) {
                    if (self.data.application_documents_code.length > 0){
                        self.loadAppDocs(defer, data.data);
                    } else {
                        delete self.saving;
                        defer.resolve({jobData: self.data.job, applicant: data.data});
                    }
                } else {
                    delete self.saving;
                    if (data && (data.data == "USER_ALREADY_APPLIED" || data.data == "DUPLICATED_REQUEST")) {
                        self.userAlreadyApplied = true;
                        defer.reject(data);
                    } else if (data && data.data == "EMPLOYER_CANNOT_APPLY") {
                        self.employerConnotApply = true;
                        defer.reject(data);
                        self.onRequestError($filter("translate")("You can not add this applicant"));
                    } else {
                        console.error(data);
                        self.saveError = true;
                        defer.reject(data);
                    }
                }
            }).error(function (err) {
                delete self.saving;
                console.error(err);
                self.saveError = true;
                defer.reject(err);
            });
        }, function () {
            delete self.saving;
            defer.reject();
            scope.$digest();
        });

        return defer.promise;
    };

    self.validator.validateCustom = function (field, optionsField, rule, showError, callback) {

        var value = self.validator.getFieldValue(field);

        switch (rule.name) {
            case 'emailServerValidation':

                DashboardAPI.checkUserRegistration(value)
                    .then(function (result) {

                        if (result.on_harri && result.user_info) {
                            //update first & last name
                            self.data.first_name = result.user_info.first_name;
                            self.data.last_name = result.user_info.last_name;
                            self.data.phone = result.user_info.phone;

                            setTimeout(function () {
                                $("." + formName + " input[name='first_name']").change();
                                $("." + formName + " input[name='last_name']").change();
                                $("." + formName + " input[name='phone']").change();
                            }, 300);

                            self.data.user_id = result.user_info.id;
                            self.existingEmail = true;
                        }
                        else {
                            //reset Harri user id
                            delete self.data.user_id;
                            delete self.existingEmail;
                        }

                        // Always true, this validation is not a blocker for submitting
                        callback(true);
                    });
                break;
        }
    };
};